var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignSet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1148,
    height: 672,
    viewBox: "0 0 1148 672",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xBF\xA0\xED\x8F\xB0ui",
    filter: "url(#filter0_i_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.108887,
    y: 0.330078,
    width: 1147.86,
    height: 671.388,
    rx: 34.6523,
    fill: "#634E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321317626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.706,
    y: 264.229,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.327 409.659C314.407 409.659 344.466 379.6 344.466 342.521C344.466 305.441 314.407 275.382 277.327 275.382C240.248 275.382 210.188 305.441 210.188 342.521C210.188 379.6 240.248 409.659 277.327 409.659ZM277.327 366.344C290.484 366.344 301.151 355.678 301.151 342.52C301.151 329.363 290.484 318.697 277.327 318.697C264.17 318.697 253.504 329.363 253.504 342.52C253.504 355.678 264.17 366.344 277.327 366.344Z",
    fill: "url(#paint0_radial_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.964 297.245C285.854 299.262 289.237 301.624 294.108 303.607C299.315 305.726 303.672 306.115 307.438 306.451C312.898 306.938 317.119 307.315 320.892 312.691C324.329 317.587 322.579 320.598 320.036 324.975C317.86 328.72 315.103 333.464 314.515 341.242C313.872 349.753 315.825 354.631 317.591 359.042C319.326 363.374 320.881 367.256 319.617 373.686C317.904 382.401 308.141 382.923 297.277 383.504C291.961 383.789 286.382 384.087 281.354 385.366C276.459 386.612 272.869 388.786 269.707 390.701C262.983 394.773 258.196 397.672 246.918 387.962C236.888 379.327 238.526 374.016 240.821 366.571C242.32 361.708 244.099 355.935 243.091 347.731C241.818 337.368 237.686 330.56 234.341 325.05C230.984 319.52 228.42 315.296 230.337 310.095C232.555 304.077 238.631 304.6 244.34 305.092C248.479 305.449 252.426 305.789 254.57 303.607C255.995 302.157 256.922 300.91 257.741 299.809C259.855 296.966 261.246 295.095 268.6 293.224C274.906 291.621 278.289 293.982 282.964 297.245ZM277.327 366.345C290.484 366.345 301.151 355.679 301.151 342.522C301.151 329.364 290.484 318.698 277.327 318.698C264.17 318.698 253.504 329.364 253.504 342.522C253.504 355.679 264.17 366.345 277.327 366.345Z",
    fill: "#634E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3465516",
    filter: "url(#filter1_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.299,
    y: 318.698,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(45.0091 241.299 318.698)",
    fill: "#FFA6CB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465517",
    x: 307.647,
    y: 326.176,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-28.963 307.647 326.176)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465518",
    x: 254.623,
    y: 306.268,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(-114.181 254.623 306.268)",
    fill: "#89C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465520",
    x: 302.704,
    y: 357.519,
    width: 3.43394,
    height: 9.94561,
    rx: 1.71697,
    transform: "rotate(162.946 302.704 357.519)",
    fill: "#2998FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465519",
    x: 244.38,
    y: 363.854,
    width: 3.102,
    height: 10.4063,
    rx: 1.551,
    transform: "rotate(-14.7713 244.38 363.854)",
    fill: "#FF539B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 255.67,
    cy: 316.532,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 74",
    filter: "url(#filter2_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.592,
    cy: 343.604,
    r: 3.24865,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 75",
    filter: "url(#filter3_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 274.079,
    cy: 378.256,
    r: 3.24865,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 308.731,
    cy: 365.262,
    r: 3.24865,
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77",
    cx: 289.239,
    cy: 304.62,
    r: 1.08288,
    fill: "#FF6B00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.481,
    y: 264.229,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086310_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.943 387.149C448.591 414.851 491.028 417.327 518.731 392.68C546.433 368.033 548.909 325.595 524.262 297.893C499.614 270.19 457.177 267.714 429.475 292.361C401.772 317.009 399.296 359.447 423.943 387.149ZM456.304 358.357C465.05 368.187 480.108 369.066 489.938 360.32C499.768 351.574 500.647 336.516 491.901 326.686C483.155 316.856 468.097 315.977 458.267 324.723C448.437 333.469 447.558 348.528 456.304 358.357Z",
    fill: "url(#paint1_radial_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.675 316.635C512.089 320.135 512.574 324.232 514.331 329.19C516.208 334.488 518.814 338.002 521.066 341.039C524.331 345.442 526.855 348.845 525.348 355.238C523.974 361.06 520.562 361.755 515.6 362.764C511.357 363.627 505.98 364.721 499.778 369.452C492.992 374.629 490.646 379.331 488.524 383.582C486.441 387.758 484.574 391.5 478.93 394.83C471.281 399.343 464.401 392.396 456.746 384.666C453 380.884 449.068 376.914 444.77 374.008C440.586 371.179 436.576 369.942 433.043 368.852C425.531 366.535 420.183 364.886 419.941 350.006C419.725 336.773 424.782 334.466 431.869 331.232C436.498 329.119 441.994 326.611 447.454 320.405C454.35 312.565 456.689 304.953 458.582 298.792C460.483 292.607 461.934 287.884 467.093 285.859C473.064 283.516 476.712 288.403 480.139 292.995C482.624 296.324 484.994 299.499 488.049 299.651C490.079 299.751 491.627 299.615 492.994 299.495C496.523 299.184 498.845 298.98 505.131 303.231C510.521 306.876 511.006 310.973 511.675 316.635ZM456.304 358.355C465.05 368.185 480.109 369.063 489.938 360.317C499.768 351.572 500.647 336.513 491.901 326.683C483.155 316.853 468.097 315.975 458.267 324.72C448.437 333.466 447.558 348.525 456.304 358.355Z",
    fill: "#634E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3465516_2",
    filter: "url(#filter4_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.261,
    y: 293.848,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(93.3487 468.261 293.848)",
    fill: "#FFA6CB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465517_2",
    x: 506.468,
    y: 354.307,
    width: 6.4973,
    height: 22.7872,
    rx: 3.24865,
    transform: "rotate(19.3767 506.468 354.307)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465518_2",
    x: 486.096,
    y: 301.46,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(-65.8418 486.096 301.46)",
    fill: "#89C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465520_2",
    x: 479.766,
    y: 371.447,
    width: 3.43394,
    height: 9.94561,
    rx: 1.71697,
    transform: "rotate(-148.714 479.766 371.447)",
    fill: "#2998FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465519_2",
    x: 436.265,
    y: 332.085,
    width: 3.102,
    height: 10.4063,
    rx: 1.551,
    transform: "rotate(33.5683 436.265 332.085)",
    fill: "#FF539B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465521",
    x: 423.855,
    y: 292.5,
    width: 3.102,
    height: 10.4063,
    rx: 1.551,
    transform: "rotate(10.4497 423.855 292.5)",
    fill: "#FF539B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_2",
    cx: 479.123,
    cy: 309.064,
    r: 2.16577,
    transform: "rotate(48.3396 479.123 309.064)",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 80",
    filter: "url(#filter5_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 431.989,
    cy: 369.402,
    r: 2.16577,
    transform: "rotate(48.3396 431.989 369.402)",
    fill: "#FFDA7B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 74_2",
    filter: "url(#filter6_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 449.54,
    cy: 316.544,
    r: 3.24865,
    transform: "rotate(48.3396 449.54 316.544)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 75_2",
    filter: "url(#filter7_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.246,
    cy: 363.848,
    r: 3.24865,
    transform: "rotate(48.3396 445.246 363.848)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76_2",
    cx: 477.988,
    cy: 381.097,
    r: 3.24865,
    transform: "rotate(48.3396 477.988 381.097)",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 79",
    cx: 533.143,
    cy: 373.097,
    r: 3.24865,
    transform: "rotate(48.3396 533.143 373.097)",
    fill: "#FFAA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77_2",
    cx: 510.336,
    cy: 326.226,
    r: 1.08288,
    transform: "rotate(48.3396 510.336 326.226)",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78",
    cx: 499.764,
    cy: 294.238,
    r: 1.08288,
    transform: "rotate(48.3396 499.764 294.238)",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.257,
    y: 264.229,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086310_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M736.706 329.321C729.416 292.966 694.033 269.403 657.677 276.694C621.321 283.984 597.759 319.367 605.049 355.723C612.34 392.078 647.722 415.641 684.078 408.35C720.434 401.06 743.996 365.677 736.706 329.321ZM694.236 337.837C691.649 324.937 679.094 316.576 666.193 319.163C653.293 321.75 644.932 334.305 647.519 347.205C650.106 360.106 662.661 368.467 675.562 365.88C688.462 363.293 696.823 350.738 694.236 337.837Z",
    fill: "url(#paint2_radial_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.377 345.895C626.786 342.666 628.436 338.884 629.423 333.718C630.477 328.196 630.002 323.848 629.591 320.089C628.995 314.64 628.535 310.428 633.063 305.671C637.188 301.338 640.484 302.462 645.277 304.095C649.376 305.493 654.569 307.263 662.311 306.31C670.783 305.267 675.182 302.393 679.159 299.794C683.066 297.241 686.566 294.954 693.119 294.929C702 294.895 704.432 304.365 707.138 314.902C708.462 320.058 709.851 325.469 712.094 330.148C714.277 334.702 717.115 337.795 719.614 340.519C724.93 346.311 728.713 350.435 721.41 363.402C714.915 374.933 709.386 374.372 701.635 373.586C696.572 373.072 690.562 372.462 682.716 375.064C672.806 378.349 666.944 383.739 662.199 388.102C657.436 392.481 653.799 395.826 648.323 394.969C641.986 393.977 641.304 387.918 640.664 382.223C640.2 378.094 639.758 374.158 637.196 372.484C635.495 371.373 634.09 370.709 632.849 370.122C629.646 368.609 627.538 367.613 624.258 360.77C621.446 354.902 623.096 351.121 625.377 345.895ZM694.236 337.837C691.649 324.936 679.094 316.575 666.193 319.162C653.293 321.749 644.932 334.304 647.519 347.205C650.106 360.105 662.661 368.466 675.561 365.879C688.462 363.292 696.823 350.737 694.236 337.837Z",
    fill: "#634E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3465516_3",
    filter: "url(#filter8_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 654.603,
    y: 382.531,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-56.33 654.603 382.531)",
    fill: "#FFA6CB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465517_3",
    x: 648.891,
    y: 316.008,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-130.302 648.891 316.008)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465518_3",
    x: 639.796,
    y: 371.911,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(144.479 639.796 371.911)",
    fill: "#89C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465520_3",
    x: 680.593,
    y: 314.692,
    width: 3.43394,
    height: 9.94561,
    rx: 1.71697,
    transform: "rotate(61.6068 680.593 314.692)",
    fill: "#2998FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465519_3",
    x: 698.271,
    y: 370.631,
    width: 3.102,
    height: 10.4063,
    rx: 1.551,
    transform: "rotate(-116.11 698.271 370.631)",
    fill: "#FF539B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_3",
    cx: 649.654,
    cy: 368.867,
    r: 2.16577,
    transform: "rotate(-101.339 649.654 368.867)",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 74_3",
    filter: "url(#filter9_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 678.965,
    cy: 377.348,
    r: 3.24865,
    transform: "rotate(-101.339 678.965 377.348)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 75_3",
    filter: "url(#filter10_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 706.554,
    cy: 338.681,
    r: 3.24865,
    transform: "rotate(-101.339 706.554 338.681)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76_3",
    cx: 687,
    cy: 307.259,
    r: 3.24865,
    transform: "rotate(-101.339 687 307.259)",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78_2",
    cx: 655.829,
    cy: 277.04,
    r: 3.24865,
    transform: "rotate(-101.339 655.829 277.04)",
    fill: "#FF7FBD"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77_3",
    cx: 631.375,
    cy: 338.295,
    r: 1.08288,
    transform: "rotate(-101.339 631.375 338.295)",
    fill: "#FF6B00"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 790.032,
    y: 264.229,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086310_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.653 409.659C904.733 409.659 934.792 379.6 934.792 342.521C934.792 305.441 904.733 275.382 867.653 275.382C830.573 275.382 800.514 305.441 800.514 342.521C800.514 379.6 830.573 409.659 867.653 409.659ZM867.653 366.344C880.81 366.344 891.476 355.678 891.476 342.52C891.476 329.363 880.81 318.697 867.653 318.697C854.496 318.697 843.829 329.363 843.829 342.52C843.829 355.678 854.496 366.344 867.653 366.344Z",
    fill: "url(#paint3_radial_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M872.53 294.479C874.45 295.437 876.915 296.666 880.493 298.122C885.317 300.086 890.383 300.977 895.161 301.818C903.016 303.2 910.097 304.446 914.062 310.094C917.794 315.41 916.184 319.831 913.951 325.965C912.368 330.313 910.472 335.522 909.942 342.521C909.396 349.744 910.702 354.505 911.782 358.439C913.224 363.695 914.261 367.476 909.942 373.685C904.05 382.158 897.902 380.46 890.693 378.469C885.721 377.096 880.243 375.584 873.996 377.173C869.429 378.335 865.207 380.556 861.09 382.723C851.411 387.816 842.313 392.603 830.68 382.587C820.312 373.661 824.563 367.006 828.84 360.31C831.402 356.297 833.975 352.27 833.417 347.73C832.144 337.367 828.012 330.559 824.667 325.049C821.31 319.519 818.746 315.295 820.663 310.094C822.881 304.076 828.956 304.599 834.665 305.091C838.805 305.448 842.752 305.788 844.896 303.606C846.32 302.156 847.248 300.909 848.067 299.807C850.18 296.965 851.571 295.094 858.926 293.223C866.266 291.356 867.606 292.024 872.53 294.479ZM867.653 366.344C880.81 366.344 891.476 355.678 891.476 342.52C891.476 329.363 880.81 318.697 867.653 318.697C854.495 318.697 843.829 329.363 843.829 342.52C843.829 355.678 854.495 366.344 867.653 366.344Z",
    fill: "#634E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3465516_4",
    filter: "url(#filter11_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 831.625,
    y: 318.698,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(45.0091 831.625 318.698)",
    fill: "#FFA6CB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465517_4",
    x: 888.073,
    y: 293.69,
    width: 6.4973,
    height: 22.9224,
    rx: 3.24865,
    transform: "rotate(-28.963 888.073 293.69)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465518_4",
    x: 844.949,
    y: 306.268,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(-114.181 844.949 306.268)",
    fill: "#89C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465520_4",
    x: 893.029,
    y: 357.519,
    width: 3.43394,
    height: 9.94561,
    rx: 1.71697,
    transform: "rotate(162.946 893.029 357.519)",
    fill: "#2998FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465519_4",
    x: 834.706,
    y: 363.854,
    width: 3.102,
    height: 10.4063,
    rx: 1.551,
    transform: "rotate(-14.7713 834.706 363.854)",
    fill: "#FF539B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_4",
    cx: 845.995,
    cy: 316.532,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 74_4",
    filter: "url(#filter12_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 831.918,
    cy: 343.604,
    r: 3.24865,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 75_4",
    filter: "url(#filter13_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 864.404,
    cy: 378.256,
    r: 3.24865,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76_4",
    cx: 899.056,
    cy: 365.262,
    r: 3.24865,
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77_4",
    cx: 879.564,
    cy: 304.62,
    r: 1.08288,
    fill: "#FF6B00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_5"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.706,
    y: 424.839,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086310_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.155 489.931C335.864 453.575 300.482 430.013 264.126 437.303C227.77 444.594 204.208 479.976 211.498 516.332C218.789 552.688 254.171 576.25 290.527 568.96C326.883 561.669 350.445 526.287 343.155 489.931ZM300.685 498.447C298.098 485.546 285.543 477.185 272.642 479.772C259.742 482.359 251.381 494.914 253.968 507.815C256.555 520.715 269.11 529.076 282.01 526.489C294.911 523.902 303.272 511.347 300.685 498.447Z",
    fill: "url(#paint4_radial_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.826 506.506C233.235 503.276 234.886 499.495 235.872 494.328C236.926 488.806 236.451 484.458 236.04 480.699C235.444 475.25 234.984 471.038 239.512 466.281C243.637 461.949 246.934 463.072 251.726 464.706C255.825 466.103 261.018 467.873 268.76 466.92C277.232 465.878 281.631 463.003 285.608 460.404C289.515 457.851 293.015 455.564 299.568 455.539C308.449 455.505 310.881 464.975 313.587 475.512C314.911 480.668 316.301 486.08 318.543 490.758C320.727 495.313 323.564 498.405 326.063 501.129C331.379 506.922 335.162 511.045 327.859 524.012C321.364 535.544 315.835 534.983 308.084 534.196C303.022 533.683 297.011 533.073 289.165 535.674C279.255 538.96 273.393 544.35 268.648 548.713C263.885 553.092 260.248 556.436 254.772 555.579C248.435 554.588 247.754 548.528 247.113 542.833C246.649 538.705 246.207 534.768 243.646 533.095C241.944 531.983 240.539 531.319 239.298 530.733C236.095 529.219 233.988 528.223 230.708 521.38C227.895 515.513 229.545 511.731 231.826 506.506ZM300.685 498.447C298.098 485.547 285.543 477.186 272.643 479.773C259.742 482.36 251.381 494.915 253.968 507.815C256.555 520.716 269.11 529.077 282.011 526.49C294.911 523.903 303.272 511.348 300.685 498.447Z",
    fill: "#634E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3465516_5",
    filter: "url(#filter14_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.052,
    y: 543.141,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-56.33 261.052 543.141)",
    fill: "#FFA6CB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465517_5",
    x: 255.34,
    y: 476.618,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-130.302 255.34 476.618)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465518_5",
    x: 246.245,
    y: 532.521,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(144.479 246.245 532.521)",
    fill: "#89C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465520_5",
    x: 287.042,
    y: 475.303,
    width: 3.43394,
    height: 9.94561,
    rx: 1.71697,
    transform: "rotate(61.6068 287.042 475.303)",
    fill: "#2998FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465519_5",
    x: 304.72,
    y: 531.241,
    width: 3.102,
    height: 10.4063,
    rx: 1.551,
    transform: "rotate(-116.11 304.72 531.241)",
    fill: "#FF539B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_5",
    cx: 256.103,
    cy: 529.477,
    r: 2.16577,
    transform: "rotate(-101.339 256.103 529.477)",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 74_5",
    filter: "url(#filter15_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 285.415,
    cy: 537.956,
    r: 3.24865,
    transform: "rotate(-101.339 285.415 537.956)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 75_5",
    filter: "url(#filter16_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 313.003,
    cy: 499.289,
    r: 3.24865,
    transform: "rotate(-101.339 313.003 499.289)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76_5",
    cx: 293.449,
    cy: 467.869,
    r: 3.24865,
    transform: "rotate(-101.339 293.449 467.869)",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78_3",
    cx: 262.278,
    cy: 437.651,
    r: 3.24865,
    transform: "rotate(-101.339 262.278 437.651)",
    fill: "#FF7FBD"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77_5",
    cx: 237.824,
    cy: 498.903,
    r: 1.08288,
    transform: "rotate(-101.339 237.824 498.903)",
    fill: "#FF6B00"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.481,
    y: 424.839,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.257,
    y: 424.839,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD_8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 790.032,
    y: 424.839,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "#FFFDF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x9C\x98\xEB\x82\xAD\xEC\x8B\x9C\xEC\x97\x90 2\xEA\xB0\x9C",
    d: "M822.961 491.557C818.383 491.557 815.684 490.101 815.684 487.524C815.684 484.947 818.383 483.461 823.052 483.461C823.719 483.461 823.598 483.764 824.053 483.764C827.54 483.764 830.238 484.947 830.238 487.524C830.238 490.101 827.54 491.557 822.961 491.557ZM813.744 494.043C813.744 493.346 814.016 492.861 814.35 492.557C814.593 492.345 814.623 492.224 814.562 492.012C814.411 491.375 814.38 490.981 814.653 490.829C814.987 490.647 815.229 490.95 815.927 491.405C816.624 491.86 817.443 492.163 818.534 492.224C820.02 492.315 827.691 492.285 828.874 492.163C829.844 492.072 830.177 491.799 830.663 491.799C831.057 491.799 831.239 492.133 831.269 492.497C831.33 493.134 831.693 493.406 831.693 494.316C831.693 495.59 831.026 496.378 830.117 496.378C829.51 496.378 829.359 496.348 828.904 496.348C828.661 496.348 827.176 496.348 825.447 496.378V501.623C825.447 502.26 824.871 502.715 824.083 502.927C823.477 503.079 822.324 503.139 821.718 503.139C820.808 503.139 820.354 502.776 820.354 502.048V496.408C819.929 496.408 819.595 496.439 819.444 496.439C818.656 496.499 818.352 497.469 817.14 497.469C815.896 497.469 815.502 496.348 815.108 496.166C814.623 495.923 813.744 495.377 813.744 494.043ZM814.865 481.339C814.865 480.793 815.047 480.52 815.411 480.217C815.563 480.096 815.623 480.035 815.593 479.823C815.533 479.459 815.623 479.307 815.775 479.247C815.987 479.186 816.139 479.307 816.472 479.489C816.867 479.701 817.746 479.823 818.413 479.853C819.262 479.883 821.354 479.853 823.052 479.853C824.598 479.853 826.782 479.853 827.721 479.762C828.783 479.671 829.116 479.247 829.601 479.247C829.814 479.247 829.874 479.368 829.965 479.61C830.056 479.883 830.147 480.005 830.45 480.308C830.814 480.641 831.026 480.884 831.026 481.521C831.026 482.946 829.965 483.522 829.328 483.522C828.601 483.522 828.146 483.249 827.297 483.097C826.418 482.946 824.538 482.855 823.082 482.855C821.718 482.855 820.444 482.915 819.444 483.067C818.413 483.219 817.807 483.613 817.079 483.613C816.442 483.613 816.078 483.006 815.775 482.764C815.563 482.612 814.865 482.248 814.865 481.339ZM818.079 477.579C818.079 477.064 818.352 476.73 818.565 476.578C818.747 476.457 818.777 476.427 818.747 476.275C818.716 476.093 818.777 475.881 818.959 475.851C819.141 475.82 819.323 475.972 819.505 476.033C819.808 476.154 820.202 476.215 820.596 476.245C821.233 476.306 824.598 476.275 825.417 476.184C825.933 476.124 826.296 475.851 826.569 475.851C826.842 475.851 826.903 476.033 826.994 476.215C827.085 476.396 827.206 476.487 827.449 476.7C827.691 476.912 827.843 477.245 827.843 477.64C827.843 478.762 827.115 479.338 826.418 479.338C826.054 479.338 825.933 479.277 825.538 479.247C824.72 479.186 821.354 479.216 820.626 479.277C820.232 479.307 820.111 479.368 819.808 479.368C819.292 479.368 819.08 479.034 818.868 478.913C818.656 478.762 818.079 478.428 818.079 477.579ZM820.384 487.524C820.384 488.161 821.324 488.494 822.961 488.494C824.598 488.494 825.538 488.161 825.538 487.524C825.538 486.857 824.629 486.493 823.355 486.493C823.113 486.493 823.022 486.736 822.658 486.736C821.293 486.615 820.384 486.887 820.384 487.524ZM830.723 476.275C830.723 475.82 831.633 475.699 832.421 475.79C832.906 475.851 833.028 475.82 833.179 475.669C833.482 475.366 833.907 475.032 834.817 475.032C836.514 475.032 837.03 476.336 837.363 476.457C837.818 476.639 838.546 477.064 838.546 478.034C838.546 479.125 837.849 479.489 837.849 479.853V501.623C837.849 502.654 836.302 503.443 834.119 503.443C833.21 503.443 832.755 503.079 832.755 502.351V479.762C832.755 478.883 832.573 478.307 831.875 477.579C831.178 476.851 830.723 476.669 830.723 476.275ZM854.674 503.443C847.761 503.443 844.092 501.502 844.092 497.833C844.092 494.286 848.125 492.012 854.371 492.012C854.947 492.012 855.402 492.163 855.766 492.406H856.251C861.86 492.406 865.256 494.437 865.256 497.833C865.256 501.502 861.587 503.443 854.674 503.443ZM841.333 477.882C841.333 477.518 841.94 477.427 842.546 477.488C843.031 477.549 843.152 477.488 843.304 477.336C843.607 477.033 844.032 476.7 844.941 476.7C846.609 476.7 847.124 478.003 847.458 478.125C847.913 478.307 848.64 478.58 848.64 479.55C848.64 480.641 847.943 480.975 847.943 482.127V486.311C847.943 486.554 848.064 486.675 848.307 486.675H853.219C854.977 486.675 856.524 484.977 856.797 484.583C857.039 484.219 857.615 484.462 857.433 484.856C857.221 485.311 857.039 485.644 856.979 485.978C856.948 486.19 857.07 486.311 857.251 486.433C857.555 486.645 858.282 486.948 858.282 487.767C858.282 488.585 857.706 489.434 857.312 489.95C856.888 490.496 856.16 490.678 854.917 490.678H845.002C843.486 490.678 842.879 490.071 842.879 488.555V481.43C842.879 480.247 842.788 479.762 842.364 479.156C841.818 478.367 841.333 478.307 841.333 477.882ZM849.641 497.833C849.641 498.864 851.46 499.44 854.674 499.44C858.768 499.44 859.707 498.591 859.707 497.682C859.707 496.954 858.828 496.135 856.099 496.135C855.432 496.135 855.705 496.499 854.674 496.499C854.128 496.499 853.674 496.378 853.128 496.378C851.036 496.378 849.641 496.954 849.641 497.833ZM857.615 476.275C857.615 475.82 858.525 475.699 859.313 475.79C859.798 475.851 859.92 475.82 860.071 475.669C860.375 475.366 860.799 475.032 861.709 475.032C863.407 475.032 863.922 476.336 864.256 476.457C864.71 476.639 865.438 477.064 865.438 478.034C865.438 479.125 864.741 479.489 864.741 479.853V482.855C864.741 483.037 864.892 483.219 865.105 483.158C865.741 483.006 866.105 482.521 866.772 482.521C867.075 482.521 867.288 482.612 867.348 482.885C867.409 483.158 867.53 483.279 867.833 483.37C868.41 483.522 868.925 483.825 868.925 484.795C868.925 486.372 868.228 487.676 867.197 487.676C866.226 487.676 865.65 487.191 865.074 487.1C864.892 487.069 864.741 487.221 864.741 487.403V490.344C864.741 491.375 863.194 491.86 861.011 491.86C860.102 491.86 859.647 491.496 859.647 490.769V479.762C859.647 478.883 859.465 478.307 858.768 477.579C858.07 476.851 857.615 476.669 857.615 476.275ZM872.713 500.259C871.288 500.259 870.499 499.349 870.499 498.47C870.499 497.53 870.742 497.318 870.742 496.742C870.742 496.287 870.105 496.196 870.105 495.802C870.105 495.59 870.226 495.468 870.59 495.377C871.257 495.226 871.833 495.044 872.44 494.498C874.987 492.194 876.503 486.766 876.503 482.097C876.503 481.49 876.26 481.339 875.654 480.975C875.108 480.641 874.471 480.096 874.471 479.55C874.471 479.065 875.138 479.186 875.745 479.034C876.472 478.852 876.654 478.701 876.776 478.307C876.897 477.882 877.17 476.942 878.231 476.942C879.292 476.942 880.172 477.488 880.596 477.973C880.99 478.428 881.112 478.822 881.384 478.913C882.233 479.156 883.022 479.762 883.022 480.763C883.022 482.066 881.597 482.157 881.597 482.855C881.597 486.615 882.597 491.799 885.205 494.134C885.811 494.68 886.509 494.892 886.872 495.074C887.176 495.226 887.267 495.347 887.267 495.559C887.267 495.953 886.782 496.075 886.782 496.651C886.782 497.166 886.994 497.56 886.994 498.197C886.994 499.167 886.387 500.107 885.175 500.107C882.203 500.107 879.838 495.59 879.292 492.982C879.201 492.588 878.928 492.618 878.837 492.982C878.049 496.166 876.018 500.259 872.713 500.259ZM887.115 476.275C887.115 475.82 888.025 475.699 888.813 475.79C889.298 475.851 889.419 475.82 889.571 475.669C889.874 475.366 890.299 475.032 891.208 475.032C892.906 475.032 893.422 476.336 893.755 476.457C894.21 476.639 894.938 477.064 894.938 478.034C894.938 479.125 894.24 479.489 894.24 479.853V501.623C894.24 502.654 892.694 503.443 890.511 503.443C889.601 503.443 889.147 503.079 889.147 502.351V479.762C889.147 478.883 888.965 478.307 888.267 477.579C887.57 476.851 887.115 476.669 887.115 476.275ZM919.859 503.443C919.04 503.443 918.646 503.139 918.646 502.412L918.616 479.762C918.616 478.883 918.434 477.761 917.737 477.094C917.282 476.639 917.07 476.548 917.07 476.275C917.07 475.881 917.737 475.79 918.282 475.82C918.707 475.851 918.828 475.82 918.98 475.669C919.283 475.366 919.707 475.032 920.617 475.032C921.921 475.032 922.527 476.336 922.861 476.457C923.316 476.639 923.922 477.064 923.922 478.034C923.922 479.125 923.225 479.489 923.225 479.853V501.957C923.225 502.988 921.648 503.443 919.859 503.443ZM898.847 489.222C898.847 484.644 899.726 481.217 901.576 479.489C902.516 478.61 903.152 478.367 903.637 478.185C904.365 477.913 904.214 477.245 904.577 477.245C905.214 477.245 905.73 477.64 906.033 478.307C908.762 478.701 910.52 481.551 911.005 486.342H912.764V480.702C912.764 479.823 912.582 478.701 911.885 478.034C911.43 477.579 911.218 477.488 911.218 477.215C911.218 476.821 911.824 476.73 912.37 476.76C912.794 476.791 912.916 476.76 913.067 476.609C913.37 476.306 913.795 475.972 914.705 475.972C916.008 475.972 916.645 477.276 916.979 477.397C917.433 477.579 917.949 478.003 917.949 478.974C917.949 480.065 917.251 480.429 917.251 480.793V501.502C917.251 502.533 915.766 502.988 913.977 502.988C913.158 502.988 912.764 502.685 912.764 501.957V491.466H911.066C910.642 497.075 908.58 500.259 905.002 500.259C900.939 500.259 898.847 496.226 898.847 489.222ZM903.274 489.222C903.274 493.406 903.759 495.529 905.002 495.529C906.245 495.529 906.73 493.406 906.73 489.222C906.73 484.947 906.002 482.824 905.457 482.824C905.032 482.824 905.123 483.583 904.517 483.552C903.789 483.522 903.274 485.402 903.274 489.222ZM856.999 521.917C856.999 519.976 855.847 519.279 854.513 519.279C852.754 519.279 851.996 520.219 851.632 521.159C851.45 521.613 851.753 521.947 851.723 522.25C851.693 522.523 851.571 522.735 850.904 522.735C849.601 522.735 848.085 522.311 846.993 521.431C846.538 521.068 846.478 520.583 846.659 519.855C847.387 516.944 850.207 514.488 854.634 514.488C859.667 514.488 862.487 517.52 862.487 521.795C862.487 523.615 861.608 525.585 860.213 527.283C858.394 529.466 856.514 531.559 854.664 533.166H857.15C857.696 533.166 858.121 533.135 858.636 532.923C859.334 532.62 859.879 532.195 860.455 532.195C860.819 532.195 861.153 532.377 861.274 533.014C861.365 533.469 861.759 533.59 862.305 533.893C863.002 534.318 863.366 534.712 863.366 535.682C863.366 537.229 862.335 538.199 860.577 538.199C859.849 538.199 859.425 537.956 858.576 537.896C857.575 537.835 851.905 537.774 850.935 537.805C849.964 537.835 850.086 538.108 849.024 538.108C847.327 538.108 845.992 536.258 845.992 534.409C845.992 533.378 846.296 532.771 846.781 532.802C847.448 532.832 847.903 532.711 848.539 532.195C851.026 530.164 853.512 527.526 855.543 525.07C856.423 524.009 856.999 522.887 856.999 521.917ZM874.299 514.852C875.057 514.852 876.088 515.246 876.816 515.883C877.513 516.489 877.332 516.853 877.665 517.156C878.09 517.52 878.423 518.066 878.423 518.672C878.423 519.673 877.665 519.734 877.665 520.431C877.665 529.103 874.876 537.259 868.66 537.259C867.568 537.259 866.901 536.562 866.568 535.743C866.295 535.076 866.113 534.682 865.597 534.348C865.325 534.136 864.961 533.893 864.961 533.56C864.961 533.348 865.021 533.166 865.325 533.105C865.688 533.075 865.931 533.135 866.932 532.953C871.54 532.013 872.753 525.434 872.753 520.704C872.753 520.249 872.601 520.097 872.147 520.097C871.692 520.097 871.298 520.097 870.843 520.128C869.873 520.219 869.691 520.916 868.629 520.916C867.78 520.916 867.417 520.188 867.144 519.824C866.901 519.491 865.567 519.248 865.567 517.49C865.567 516.338 866.507 516.065 866.446 515.762C866.386 515.398 866.355 514.822 866.689 514.731C866.992 514.64 867.174 514.882 867.659 515.155C868.296 515.519 869.115 515.731 869.994 515.792C870.449 515.822 871.419 515.852 871.934 515.822C872.571 515.792 872.783 515.731 872.996 515.458C873.208 515.185 873.511 514.852 874.299 514.852ZM877.847 514.215C877.847 513.821 878.453 513.73 878.999 513.76C879.424 513.791 879.545 513.76 879.697 513.609C880 513.306 880.424 512.972 881.334 512.972C882.638 512.972 883.274 514.276 883.608 514.397C884.063 514.579 884.578 515.003 884.578 515.974C884.578 517.065 883.881 517.429 883.881 517.793V523.463H885.579L885.548 516.762C885.548 515.883 885.367 514.761 884.669 514.094C884.214 513.639 884.002 513.548 884.002 513.275C884.002 512.881 884.669 512.79 885.215 512.82C885.639 512.851 885.761 512.82 885.912 512.669C886.215 512.366 886.64 512.032 887.55 512.032C888.853 512.032 889.49 513.336 889.824 513.457C890.278 513.639 890.885 514.064 890.885 515.034C890.885 516.125 890.188 516.489 890.188 516.853V538.957C890.188 539.988 888.581 540.443 886.792 540.443C885.973 540.443 885.579 540.139 885.579 539.412V528.072H883.881V538.502C883.881 539.533 882.395 539.988 880.606 539.988C879.787 539.988 879.393 539.685 879.393 538.957V517.702C879.393 516.823 879.211 515.701 878.514 515.034C878.059 514.579 877.847 514.488 877.847 514.215Z",
    fill: "#593921"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\xEB\x8B\xA8\xEC\xB2\xB4\xEC\xA3\xBC\xEB\xAC\xB8 02-991-9779",
    d: "M451.201 226.999H453.8V231.261H451.201V239.006H446.809V222.58H451.201V226.999ZM445.77 234.691C444.626 235.185 442.547 235.471 440.468 235.471H430.852V222.84H444.496V226.557H435.27V231.781H440.65C442.651 231.781 444.6 231.521 445.77 231.053V234.691ZM436.076 237.004V240.825H451.513V244.775H431.605V237.004H436.076ZM468.274 231.027V222.684H472.328V244.385H468.274V241.526L464.869 243.476L462.063 238.694C460.763 241.916 458.684 243.632 455.877 243.736V239.551C458.034 239.291 459.386 235.263 459.464 229.026H456.215V225.101H459.464V222.502H463.622V225.101H466.845V229.026H463.622C463.596 230.585 463.518 232.04 463.336 233.366L468.274 241.345V235.159H465.857V231.027H468.274ZM473.862 222.58H477.968V244.775H473.862V222.58ZM501.876 234.665L492.39 231.001C489.895 233.262 486.178 234.613 482.228 234.639V230.637C485.633 230.585 488.959 229.156 490.285 226.817H482.618V222.84H502.629V226.817H495.145C495.067 227.128 494.937 227.44 494.807 227.726L503.539 231.027L501.876 234.665ZM503.851 236.251V240.305H494.859V245.295H490.389V240.305H481.396V236.251H503.851ZM528.019 222.58V231.988H508.267V222.58H528.019ZM523.652 228.532V226.037H512.633V228.532H523.652ZM506.915 233.288H529.37V236.9H520.352V239.915H515.934V236.9H506.915V233.288ZM512.685 238.2V241.137H528.331V244.775H508.215V238.2H512.685ZM548.113 222.658C552.739 222.658 556.222 226.375 556.222 233.808C556.222 241.215 552.739 244.931 548.113 244.931C543.487 244.931 540.005 241.215 540.005 233.808C540.005 226.375 543.487 222.658 548.113 222.658ZM548.113 226.791C546.034 226.791 544.475 228.974 544.475 233.808C544.475 238.616 546.034 240.799 548.113 240.799C550.192 240.799 551.752 238.616 551.752 233.808C551.752 228.974 550.192 226.791 548.113 226.791ZM566.152 222.658C570.908 222.658 573.715 225.465 573.715 229.312C573.715 231.521 572.65 233.418 568.933 237.264L565.892 240.409H574.131V244.411H558.979V241.708L565.918 234.561C568.465 231.936 569.063 230.559 569.063 229.364C569.063 227.804 568.206 226.765 566.152 226.765C564.229 226.765 563.19 228.324 563.19 229.935H558.538C558.538 225.777 561.682 222.658 566.152 222.658ZM576.808 232.3H586.762V236.199H576.808V232.3ZM592.262 244.411L597.07 237.238C596.94 237.29 596.707 237.342 596.473 237.342C592.34 237.342 588.936 234.457 588.936 230.169C588.936 225.647 592.548 222.736 596.966 222.736C601.385 222.736 604.997 225.621 604.997 230.143C604.997 232.196 604.321 233.782 603.074 235.757L597.616 244.411H592.262ZM596.966 233.496C599.072 233.496 600.397 232.014 600.397 230.117C600.397 228.22 599.072 226.739 596.966 226.739C594.861 226.739 593.536 228.22 593.536 230.117C593.536 232.014 594.861 233.496 596.966 233.496ZM610.168 244.411L614.976 237.238C614.846 237.29 614.612 237.342 614.378 237.342C610.245 237.342 606.841 234.457 606.841 230.169C606.841 225.647 610.453 222.736 614.872 222.736C619.29 222.736 622.902 225.621 622.902 230.143C622.902 232.196 622.227 233.782 620.979 235.757L615.521 244.411H610.168ZM614.872 233.496C616.977 233.496 618.302 232.014 618.302 230.117C618.302 228.22 616.977 226.739 614.872 226.739C612.766 226.739 611.441 228.22 611.441 230.117C611.441 232.014 612.766 233.496 614.872 233.496ZM633.478 223.23V244.411H628.774V227.336H625.032V223.23H633.478ZM638.276 232.3H648.23V236.199H638.276V232.3ZM653.731 244.411L658.539 237.238C658.409 237.29 658.175 237.342 657.941 237.342C653.809 237.342 650.404 234.457 650.404 230.169C650.404 225.647 654.017 222.736 658.435 222.736C662.853 222.736 666.466 225.621 666.466 230.143C666.466 232.196 665.79 233.782 664.542 235.757L659.085 244.411H653.731ZM658.435 233.496C660.54 233.496 661.866 232.014 661.866 230.117C661.866 228.22 660.54 226.739 658.435 226.739C656.33 226.739 655.004 228.22 655.004 230.117C655.004 232.014 656.33 233.496 658.435 233.496ZM683.305 223.23V226.037L675.43 244.411H670.493L677.795 227.336H668.751V223.23H683.305ZM700.094 223.23V226.037L692.219 244.411H687.281L694.584 227.336H685.54V223.23H700.094ZM705.213 244.411L710.021 237.238C709.891 237.29 709.657 237.342 709.423 237.342C705.291 237.342 701.886 234.457 701.886 230.169C701.886 225.647 705.499 222.736 709.917 222.736C714.335 222.736 717.948 225.621 717.948 230.143C717.948 232.196 717.272 233.782 716.024 235.757L710.567 244.411H705.213ZM709.917 233.496C712.022 233.496 713.348 232.014 713.348 230.117C713.348 228.22 712.022 226.739 709.917 226.739C707.812 226.739 706.486 228.22 706.486 230.117C706.486 232.014 707.812 233.496 709.917 233.496Z",
    fill: "#34261C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321318006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26086308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26086305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5773 146.958C56.5773 144.311 54.9471 141.97 52.6114 140.725C39.413 133.688 30.4297 119.785 30.4297 103.784C30.4297 80.678 49.1604 61.9473 72.266 61.9473C80.5912 61.9473 88.3484 64.379 94.8662 68.5709C97.5366 70.2883 101.034 70.2883 103.704 68.5709C110.222 64.379 117.979 61.9473 126.304 61.9473C134.63 61.9473 142.387 64.379 148.905 68.5708C151.575 70.2883 155.072 70.2883 157.743 68.5708C164.26 64.379 172.018 61.9473 180.343 61.9473C203.448 61.9473 222.179 80.678 222.179 103.784C222.179 119.183 213.859 132.639 201.469 139.902C199.278 141.186 197.775 143.454 197.775 145.993V172.4C197.775 190.342 183.23 204.887 165.288 204.887H89.0639C71.122 204.887 56.5773 190.342 56.5773 172.4V146.958Z",
    fill: "#FFF7CF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321318005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.324 135.726C146.034 141.898 136.604 145.62 126.305 145.62C116.005 145.62 106.575 141.898 99.2854 135.726C91.9959 141.898 82.5656 145.62 72.266 145.62C49.1604 145.62 30.4297 126.889 30.4297 103.784C30.4297 80.678 49.1604 61.9473 72.266 61.9473C82.5656 61.9473 91.9959 65.6692 99.2854 71.8414C106.575 65.6692 116.005 61.9473 126.305 61.9473C136.604 61.9473 146.034 65.6691 153.324 71.8412C160.613 65.6691 170.044 61.9473 180.343 61.9473C203.449 61.9473 222.179 80.678 222.179 103.784C222.179 126.889 203.449 145.62 180.343 145.62C170.044 145.62 160.613 141.898 153.324 135.726Z",
    fill: "#FFF7CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5773 146.958C56.5773 144.311 54.9471 141.97 52.6114 140.725C39.413 133.688 30.4297 119.785 30.4297 103.784C30.4297 80.678 49.1604 61.9473 72.266 61.9473C80.5912 61.9473 88.3484 64.379 94.8662 68.5709C97.5366 70.2883 101.034 70.2883 103.704 68.5709C110.222 64.379 117.979 61.9473 126.304 61.9473C134.63 61.9473 142.387 64.379 148.905 68.5708C151.575 70.2883 155.072 70.2883 157.743 68.5708C164.26 64.379 172.018 61.9473 180.343 61.9473C203.448 61.9473 222.179 80.678 222.179 103.784C222.179 119.183 213.859 132.639 201.469 139.902C199.278 141.186 197.775 143.454 197.775 145.993V172.4C197.775 190.342 183.23 204.887 165.288 204.887H89.0639C71.122 204.887 56.5773 190.342 56.5773 172.4V146.958Z",
    fill: "url(#paint5_linear_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1933",
    d: "M84.0723 58.6982C93.2371 58.6982 106.232 73.7499 110.563 81.5467",
    stroke: "#634E3E",
    strokeWidth: 8.66307,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1934",
    d: "M137.133 58.6982C148.464 60.9719 158.21 72.667 162.541 80.4638",
    stroke: "#634E3E",
    strokeWidth: 8.66307,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 58.5847,
    cy: 64.3581,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72",
    cx: 40.1759,
    cy: 80.6002,
    r: 3.24865,
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 69",
    cx: 175.536,
    cy: 62.1921,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 136.552,
    cy: 80.4634,
    r: 4.33153,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_6",
    cx: 214.52,
    cy: 78.2974,
    r: 4.33153,
    fill: "#6BC1FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74_6",
    cx: 162.542,
    cy: 65.3025,
    r: 2.16577,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 112.729,
    cy: 63.1372,
    r: 4.33153,
    fill: "#FF6B00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465512",
    x: 190.715,
    y: 62.8203,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-28.963 190.715 62.8203)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465513",
    x: 77.2397,
    y: 56.2559,
    width: 6.4973,
    height: 24.0695,
    rx: 3.24865,
    transform: "rotate(45.0091 77.2397 56.2559)",
    fill: "#FFA6CB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465514",
    x: 87.0654,
    y: 67.7666,
    width: 2.73267,
    height: 10.8569,
    rx: 1.36634,
    transform: "rotate(-14.7713 87.0654 67.7666)",
    fill: "#FF6FAC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465515",
    x: 126.543,
    y: 66.8555,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(-114.181 126.543 66.8555)",
    fill: "#89C7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB0\x80\xEA\xB2\x8C \xEB\xA1\x9C\xEA\xB3\xA0\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xB9\xB5\xEB\xB9\xB5 \xEA\xB5\xAC\xEC\x9B\x80\xEA\xB3\xBC\xEC\x9E\x90\xEC\xA0\x90",
    filter: "url(#filter17_d_1932_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.1 142.094C245.346 142.094 244.362 140.913 244.362 139.241V104.412C244.362 100.574 241.213 100.082 241.213 98.6067C241.213 97.6228 242.394 97.1309 244.263 96.9341C245.149 96.8357 245.444 96.6389 245.838 96.147C246.625 95.1631 248.199 94.376 250.265 94.376C254.102 94.376 255.184 96.5405 256.07 96.7373C257.349 97.0325 258.923 98.0163 258.923 99.3938C258.923 100.968 257.939 101.755 257.939 102.936V105.494C257.939 106.183 258.234 106.478 258.923 106.478H262.465C263.154 106.478 263.449 106.183 263.449 105.494V101.558C263.449 98.2131 260.989 98.0163 260.989 96.7373C260.989 95.9502 261.776 95.5566 263.351 95.3599C264.138 95.2615 264.433 95.1631 264.925 94.6712C265.712 93.8841 266.991 93.2937 268.762 93.2937C273.189 93.2937 273.976 95.5566 274.862 95.8518C276.239 96.3437 277.223 97.2292 277.223 98.5083C277.223 99.9841 276.239 100.771 276.239 101.755V105.494C276.239 106.183 276.535 106.478 277.223 106.478H281.06C281.749 106.478 282.044 106.183 282.044 105.494V100.181C282.044 97.2292 279.781 96.9341 279.781 95.7534C279.781 95.0647 280.47 94.6712 282.044 94.4744C283.028 94.376 283.422 94.376 283.717 94.0808C284.701 93.097 285.98 92.7034 287.751 92.7034C291.981 92.7034 293.26 95.5566 294.146 95.8518C295.425 96.3437 296.901 97.426 296.901 99.0002C296.901 101.165 295.523 101.853 295.523 103.723V136.978C295.523 139.536 292.375 141.11 285.783 141.11C283.52 141.11 282.438 140.323 282.143 139.142H257.939C257.644 140.618 254.496 142.094 248.1 142.094ZM249.773 162.657C249.773 151.638 262.76 144.554 283.127 144.554C284.996 144.554 286.472 144.947 287.652 145.833H289.227C307.527 145.833 318.448 152.13 318.448 162.657C318.448 174.168 306.641 180.17 284.11 180.17C261.58 180.17 249.773 174.168 249.773 162.657ZM257.939 126.057C257.939 126.746 258.234 127.041 258.923 127.041H262.465C263.154 127.041 263.449 126.746 263.449 126.057V119.662C263.449 118.973 263.154 118.678 262.465 118.678H258.923C258.234 118.678 257.939 118.973 257.939 119.662V126.057ZM267.778 162.657C267.778 165.805 273.485 167.576 284.11 167.576C297.393 167.576 300.443 165.018 300.443 162.264C300.443 160.001 297.59 157.541 288.735 157.541C286.57 157.541 287.456 158.722 284.11 158.722C282.339 158.722 280.864 158.328 279.093 158.328C272.107 158.328 267.778 160.001 267.778 162.657ZM276.338 126.057C276.338 126.746 276.633 127.041 277.322 127.041H281.06C281.749 127.041 282.044 126.746 282.044 126.057V119.662C282.044 118.973 281.749 118.678 281.06 118.678H277.322C276.633 118.678 276.338 118.973 276.338 119.662V126.057ZM294.638 92.0147C294.638 90.5389 297.59 90.1453 300.148 90.4405C301.722 90.6373 302.115 90.5389 302.607 90.0469C303.591 89.0631 304.969 87.9808 307.92 87.9808C312.446 87.9808 314.119 92.2115 315.201 92.605C316.677 93.1953 319.038 94.5728 319.038 97.7212C319.038 101.263 316.775 102.444 316.775 103.624V113.66C316.775 114.25 317.267 114.841 317.956 114.644C320.022 114.152 321.203 112.578 323.367 112.578C324.351 112.578 325.04 112.873 325.236 113.758C325.433 114.644 325.827 115.037 326.811 115.333C328.68 115.825 330.353 116.808 330.353 119.957C330.353 125.073 328.09 129.304 324.745 129.304C321.596 129.304 319.727 127.729 317.857 127.434C317.267 127.336 316.775 127.828 316.775 128.418V138.65C316.775 141.996 311.757 143.57 305.657 143.57C302.706 143.57 301.23 142.389 301.23 140.028V103.329C301.23 100.476 300.64 98.6067 298.377 96.2454C296.114 93.8841 294.638 93.2937 294.638 92.0147ZM340.577 142.094C337.822 142.094 336.839 140.913 336.839 139.241V104.412C336.839 100.574 333.69 100.082 333.69 98.6067C333.69 97.6228 334.871 97.1309 336.74 96.9341C337.626 96.8357 337.921 96.6389 338.314 96.147C339.101 95.1631 340.676 94.376 342.742 94.376C346.579 94.376 347.661 96.5405 348.547 96.7373C349.826 97.0325 351.4 98.0163 351.4 99.3938C351.4 100.968 350.416 101.755 350.416 102.936V105.494C350.416 106.183 350.711 106.478 351.4 106.478H354.942C355.631 106.478 355.926 106.183 355.926 105.494V101.558C355.926 98.2131 353.466 98.0163 353.466 96.7373C353.466 95.9502 354.253 95.5566 355.827 95.3599C356.614 95.2615 356.91 95.1631 357.402 94.6712C358.189 93.8841 359.468 93.2937 361.239 93.2937C365.666 93.2937 366.453 95.5566 367.339 95.8518C368.716 96.3437 369.7 97.2292 369.7 98.5083C369.7 99.9841 368.716 100.771 368.716 101.755V105.494C368.716 106.183 369.011 106.478 369.7 106.478H373.537C374.226 106.478 374.521 106.183 374.521 105.494V100.181C374.521 97.2292 372.258 96.9341 372.258 95.7534C372.258 95.0647 372.947 94.6712 374.521 94.4744C375.505 94.376 375.898 94.376 376.194 94.0808C377.177 93.097 378.457 92.7034 380.228 92.7034C384.458 92.7034 385.737 95.5566 386.623 95.8518C387.902 96.3437 389.378 97.426 389.378 99.0002C389.378 101.165 388 101.853 388 103.723V136.978C388 139.536 384.852 141.11 378.26 141.11C375.997 141.11 374.915 140.323 374.619 139.142H350.416C350.121 140.618 346.972 142.094 340.577 142.094ZM342.25 162.657C342.25 151.638 355.237 144.554 375.603 144.554C377.473 144.554 378.948 144.947 380.129 145.833H381.703C400.003 145.833 410.924 152.13 410.924 162.657C410.924 174.168 399.118 180.17 376.587 180.17C354.056 180.17 342.25 174.168 342.25 162.657ZM350.416 126.057C350.416 126.746 350.711 127.041 351.4 127.041H354.942C355.631 127.041 355.926 126.746 355.926 126.057V119.662C355.926 118.973 355.631 118.678 354.942 118.678H351.4C350.711 118.678 350.416 118.973 350.416 119.662V126.057ZM360.255 162.657C360.255 165.805 365.961 167.576 376.587 167.576C389.87 167.576 392.92 165.018 392.92 162.264C392.92 160.001 390.066 157.541 381.211 157.541C379.047 157.541 379.932 158.722 376.587 158.722C374.816 158.722 373.34 158.328 371.569 158.328C364.584 158.328 360.255 160.001 360.255 162.657ZM368.815 126.057C368.815 126.746 369.11 127.041 369.798 127.041H373.537C374.226 127.041 374.521 126.746 374.521 126.057V119.662C374.521 118.973 374.226 118.678 373.537 118.678H369.798C369.11 118.678 368.815 118.973 368.815 119.662V126.057ZM387.115 92.0147C387.115 90.5389 390.066 90.1453 392.624 90.4405C394.199 90.6373 394.592 90.5389 395.084 90.0469C396.068 89.0631 397.445 87.9808 400.397 87.9808C404.923 87.9808 406.595 92.2115 407.678 92.605C409.153 93.1953 411.515 94.5728 411.515 97.7212C411.515 101.263 409.252 102.444 409.252 103.624V113.66C409.252 114.25 409.744 114.841 410.433 114.644C412.499 114.152 413.679 112.578 415.844 112.578C416.828 112.578 417.516 112.873 417.713 113.758C417.91 114.644 418.304 115.037 419.287 115.333C421.157 115.825 422.829 116.808 422.829 119.957C422.829 125.073 420.566 129.304 417.221 129.304C414.073 129.304 412.204 127.729 410.334 127.434C409.744 127.336 409.252 127.828 409.252 128.418V138.65C409.252 141.996 404.234 143.57 398.134 143.57C395.182 143.57 393.707 142.389 393.707 140.028V103.329C393.707 100.476 393.116 98.6067 390.853 96.2454C388.59 93.8841 387.115 93.2937 387.115 92.0147Z",
    fill: "#FFC530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.26 180.17C489.309 180.17 487.833 178.989 487.833 176.628V151.834C484.094 151.834 480.749 151.933 478.289 152.031C471.993 152.228 472.091 155.77 466.68 155.77C462.941 155.77 460.776 153.507 459.989 152.326C459.202 151.244 453.988 150.162 453.988 144.751C453.988 141.897 454.971 140.52 455.955 139.536C457.038 138.552 457.53 138.159 457.333 137.47C456.939 136.092 456.546 134.125 457.431 133.338C458.612 132.354 459.891 133.731 461.957 134.813C465.302 136.584 468.155 137.371 473.763 137.667C485.176 138.257 506.428 138.159 515.873 137.667C519.612 137.47 520.006 137.076 521.678 136.289C524.04 135.207 525.909 133.436 527.778 133.436C528.959 133.436 530.041 134.026 530.435 136.092C530.828 137.962 532.895 139.044 534.764 139.93C537.715 141.405 539.191 143.471 539.191 146.62C539.191 150.654 535.551 155.573 530.533 155.573C527.188 155.573 525.319 154.393 522.269 153.212C520.006 152.326 517.841 151.834 514.201 151.736C511.938 151.638 508.79 151.638 505.346 151.638V175.251C505.346 177.317 503.477 178.793 500.918 179.481C498.951 179.973 494.228 180.17 492.26 180.17ZM461.859 101.952C461.859 98.1147 465.302 97.1309 465.105 95.9502C464.81 94.2776 464.81 92.605 465.892 92.3099C466.876 92.0147 467.959 93.097 469.533 93.9824C471.599 95.1631 474.747 95.8518 477.601 96.0486C481.143 96.2454 503.772 96.4421 509.773 96.147C511.84 96.0486 512.725 95.7534 513.414 94.8679C514.102 93.9824 515.677 92.9002 518.038 92.9002C520.498 92.9002 521.973 93.6873 524.138 95.655C526.303 97.6228 526.303 98.6067 527.582 99.197C530.238 100.476 531.615 103.526 531.615 105.789C531.615 109.724 529.057 109.429 529.057 111.889C529.057 124.679 525.22 133.829 515.775 133.829C512.627 133.829 510.462 132.649 508.986 132.058C507.707 131.567 506.92 131.468 504.559 131.567C503.673 131.567 502.788 131.075 502.788 129.992C502.788 129.304 503.083 128.91 503.87 128.517C509.085 125.86 511.741 122.22 511.741 112.774C511.741 111.299 511.249 110.807 509.773 110.807C502.788 110.807 486.16 110.708 480.946 111.004C476.814 111.2 476.223 113.955 472.288 113.955C469.041 113.955 467.86 111.2 466.975 110.02C466.188 108.937 461.859 107.757 461.859 101.952ZM573.521 108.839C573.521 111.889 578.834 113.463 589.066 113.463C599.299 113.463 604.611 111.889 604.611 108.839C604.611 105.691 599.397 103.821 592.51 103.821C590.444 103.821 591.526 105.1 587.689 104.903C580.31 104.51 573.521 105.789 573.521 108.839ZM546.464 134.715C546.464 132.255 547.547 130.878 548.727 130.091C549.613 129.304 550.006 129.008 549.809 128.418C549.416 127.041 549.219 125.467 549.908 124.876C550.99 124.089 552.171 125.467 554.139 126.45C557.287 127.926 560.042 128.517 565.65 128.812C576.669 129.304 601.069 129.205 610.515 128.812C614.253 128.615 615.237 128.221 616.91 127.533C619.074 126.647 620.55 125.27 622.223 125.27C623.403 125.27 624.289 125.762 624.683 127.434C625.076 129.008 626.355 129.894 627.929 130.681C630.487 132.157 631.668 133.633 631.668 136.388C631.668 140.028 628.421 144.062 623.797 144.062C620.452 144.062 618.779 143.078 616.123 142.291C613.86 141.602 611.302 141.209 607.661 141.11H597.528V147.407H605.103C607.661 147.407 607.17 145.439 611.991 145.439C618.484 145.439 619.566 147.801 621.239 148.489C622.912 149.178 624.781 150.26 624.781 153.212C624.781 156.262 622.715 158.033 622.715 159.312V175.349C622.715 178.891 617.107 180.17 610.613 180.17C607.563 180.17 606.481 178.793 606.186 177.415H572.045C570.274 179.383 565.748 180.17 560.731 180.17C557.287 180.17 556.303 178.399 556.303 176.923V159.902C556.303 157.836 555.221 156.655 554.139 155.672C553.351 154.884 552.564 153.901 552.564 152.917C552.564 152.13 553.253 151.834 553.942 151.638C555.713 151.146 556.697 150.457 556.893 147.997C556.992 146.423 558.566 145.439 561.813 145.439C570.766 145.439 570.176 147.407 573.521 147.407H580.605V141.209C575.587 141.209 571.16 141.307 568.208 141.405C562.305 141.602 562.403 144.259 557.976 144.259C554.926 144.259 553.056 142.586 552.269 141.504C551.482 140.52 546.464 139.733 546.464 134.715ZM555.418 108.839C555.418 99.7873 564.568 93.7857 580.408 92.3099C587 91.7195 588.279 90.0469 589.46 90.0469C591.427 90.0469 593.002 91.2276 593.986 92.8018C606.973 92.9002 622.715 98.4099 622.715 108.839C622.715 119.465 610.515 125.368 589.066 125.368C567.618 125.368 555.418 119.465 555.418 108.839ZM572.832 164.822C572.832 165.412 573.226 165.805 573.816 165.805H605.202C605.792 165.805 606.186 165.412 606.186 164.822V160.099C606.186 159.509 605.792 159.115 605.202 159.115H573.816C573.226 159.115 572.832 159.509 572.832 160.099V164.822ZM702.106 180.17C699.154 180.17 697.679 178.989 697.679 176.628V103.329C697.679 100.476 697.088 98.6067 694.825 96.2454C692.562 93.8841 691.087 93.2937 691.087 92.0147C691.087 90.5389 694.038 90.1453 696.596 90.4405C698.17 90.6373 698.564 90.5389 699.056 90.0469C700.04 89.0631 701.417 87.9808 704.369 87.9808C709.879 87.9808 711.551 92.2115 712.633 92.605C714.109 93.1953 716.471 94.5728 716.471 97.7212C716.471 101.263 714.208 102.444 714.208 103.624V123.892C714.208 124.581 714.7 124.876 714.995 124.876C717.061 124.876 718.143 122.416 720.8 122.416C721.784 122.416 722.472 122.712 722.669 123.794C722.866 124.778 723.259 125.27 724.243 125.565C726.113 126.155 727.785 127.336 727.785 130.878C727.785 136.683 725.621 141.602 722.079 141.602C718.93 141.602 716.963 139.536 715.29 139.536C714.7 139.536 714.208 139.93 714.208 140.618V174.267C714.208 177.612 709.19 180.17 702.106 180.17ZM638.252 161.28C638.252 159.017 639.138 157.443 640.22 156.459C641.007 155.77 641.106 155.376 640.909 154.688C640.417 152.622 640.319 151.342 641.204 150.851C642.286 150.26 643.073 151.244 645.336 152.72C647.599 154.196 650.157 155.18 653.699 155.376V135.896C653.699 133.534 652.814 131.665 651.928 130.779C651.141 129.894 650.059 129.402 650.059 128.32C650.059 127.336 651.338 126.647 652.814 126.45C654.29 126.254 654.781 125.958 655.569 125.171C656.848 123.892 658.127 123.007 660.685 123.007C664.817 123.007 666.686 126.45 667.867 127.139C668.753 127.729 670.72 128.713 670.72 130.878C670.72 133.633 668.851 134.42 668.851 138.454V155.573C676.132 155.475 683.609 155.376 685.675 155.18C688.824 154.884 689.906 153.999 691.48 153.999C692.759 153.999 693.349 155.081 693.448 156.262C693.645 158.328 694.825 159.213 694.825 162.165C694.825 166.297 692.661 168.855 689.709 168.855C687.741 168.855 687.249 168.757 685.774 168.757C683.904 168.757 660.094 168.855 656.749 169.052C654.191 169.249 653.207 172.397 649.272 172.397C645.238 172.397 643.959 168.757 642.68 168.167C641.106 167.38 638.252 165.609 638.252 161.28ZM640.712 104.903C640.712 101.263 643.762 100.476 643.565 99.2954C643.369 98.1147 643.27 96.147 644.352 95.7534C645.435 95.3599 646.517 96.8357 648.386 97.7212C650.846 98.9018 653.699 99.2954 657.044 99.4922C659.111 99.5905 671.704 99.4922 673.77 99.3938C675.541 99.2954 676.23 99.0002 676.919 98.1147C677.509 97.426 678.69 96.8357 681.051 96.8357C683.019 96.8357 685.97 97.5244 687.741 99.0986C689.808 100.87 689.709 102.149 690.791 102.837C692.267 103.723 694.038 106.281 694.038 108.347C694.038 111.299 691.874 111.495 691.874 113.66C691.874 119.17 691.972 124.778 691.775 130.288C691.283 144.357 687.348 148.686 681.149 148.686C678.985 148.686 677.509 147.702 676.82 146.128C676.23 144.751 675.935 143.57 675.049 142.389C674.164 141.209 672.786 140.225 672.786 139.241C672.786 138.06 673.869 137.863 674.754 136.781C676.033 135.207 676.328 132.944 676.427 129.205C676.525 124.286 676.427 115.628 676.427 113.758C676.427 112.971 676.033 112.578 675.246 112.578C673.082 112.578 659.602 112.479 657.438 112.676C654.29 112.971 653.699 115.234 650.256 115.234C647.501 115.234 646.32 112.873 645.435 111.692C644.648 110.61 640.712 109.823 640.712 104.903ZM794.583 180.17C791.631 180.17 790.155 178.989 790.155 176.628V103.329C790.155 100.476 789.565 98.6067 787.302 96.2454C785.039 93.8841 783.563 93.2937 783.563 92.0147C783.563 90.5389 786.515 90.1453 789.073 90.4405C790.647 90.6373 791.041 90.5389 791.533 90.0469C792.517 89.0631 793.894 87.9808 796.846 87.9808C802.355 87.9808 804.028 92.2115 805.11 92.605C806.586 93.1953 808.947 94.5728 808.947 97.7212C808.947 101.263 806.684 102.444 806.684 103.624V123.892C806.684 124.581 807.176 124.876 807.472 124.876C809.538 124.876 810.62 122.416 813.276 122.416C814.26 122.416 814.949 122.712 815.146 123.794C815.343 124.778 815.736 125.27 816.72 125.565C818.589 126.155 820.262 127.336 820.262 130.878C820.262 136.683 818.097 141.602 814.555 141.602C811.407 141.602 809.439 139.536 807.767 139.536C807.176 139.536 806.684 139.93 806.684 140.618V174.267C806.684 177.612 801.667 180.17 794.583 180.17ZM731.024 155.376C731.024 154.688 731.418 154.294 732.599 153.999C734.665 153.507 736.436 152.917 738.403 151.146C746.57 143.57 751.194 126.057 751.194 115.333C751.194 114.545 750.997 114.152 750.21 114.152H746.963C744.995 114.152 744.405 116.12 741.355 116.12C738.895 116.12 737.813 113.955 737.026 112.774C736.337 111.692 733.09 110.708 733.09 106.084C733.09 102.05 735.845 100.968 735.649 99.8857C735.452 98.7051 735.452 96.9341 736.436 96.6389C737.321 96.3437 737.813 97.1309 739.289 97.918C741.257 99.0002 743.224 99.4922 746.668 99.5905C751.292 99.7873 766.641 99.7873 770.478 99.5905C774.512 99.3938 775.102 97.426 777.562 97.426C778.25 97.426 779.038 97.8196 779.333 99.0002C779.628 100.181 780.317 100.378 781.792 101.657C783.268 102.936 784.449 104.903 784.449 108.839C784.449 112.774 781.497 115.825 778.644 115.825C776.184 115.825 775.2 114.152 772.839 114.152H768.805C768.018 114.152 767.625 114.447 767.625 115.333C767.625 124.581 770.675 142.389 779.038 149.965C781.005 151.736 783.071 152.425 784.252 153.015C785.236 153.507 785.531 153.901 785.531 154.589C785.531 155.868 783.957 156.262 783.957 158.131C783.957 159.804 784.646 161.083 784.646 163.149C784.646 166.297 782.776 169.347 778.841 169.347C769.396 169.347 761.918 154.884 760.245 145.538C759.95 144.259 759.065 144.357 758.77 145.538C756.31 156.655 749.816 169.839 739.387 169.839C734.861 169.839 732.303 166.888 732.303 164.034C732.303 160.984 733.09 160.296 733.09 158.426C733.09 156.951 731.024 156.655 731.024 155.376ZM903.392 175.349C903.392 178.891 897.784 180.17 891.29 180.17C888.24 180.17 887.158 178.793 886.863 177.415H852.034C850.263 179.383 845.737 180.17 840.719 180.17C837.275 180.17 836.291 178.399 836.291 176.825V158.623C836.291 156.459 835.209 155.278 834.127 154.196C833.34 153.409 832.553 152.326 832.553 151.342C832.553 150.555 833.241 150.26 833.93 150.063C835.701 149.572 836.685 148.588 836.882 145.538C836.98 144.062 838.554 142.783 841.801 142.783C851.738 142.783 850.164 145.046 853.509 145.046H884.993C888.142 145.046 888.24 142.783 892.766 142.783C900.243 142.783 901.129 145.341 902.802 146.226C904.277 147.013 905.261 148.096 905.261 150.162C905.261 153.999 903.392 155.573 903.392 157.934V175.349ZM825.469 129.107C825.469 128.615 825.764 128.221 826.649 128.123C828.027 127.926 830.388 127.631 831.962 126.942C840.817 123.007 844.261 113.66 844.261 109.429C844.261 108.642 844.064 108.249 843.179 108.249H841.408C839.341 108.249 838.85 109.823 835.8 109.823C833.34 109.823 832.258 108.052 831.47 106.871C830.782 105.789 827.535 105.1 827.535 100.673C827.535 97.3276 830.29 96.5405 830.093 95.4583C829.896 94.2776 829.896 92.5066 830.88 92.2115C831.766 91.9163 832.258 92.7034 833.733 93.4905C835.701 94.5728 837.767 94.9663 841.112 95.1631C844.556 95.3599 860.396 95.3599 864.726 95.1631C868.858 94.9663 869.448 93.097 871.908 93.097C872.597 93.097 873.187 93.4905 873.58 94.6712C873.974 95.8518 874.761 96.0486 876.237 97.3276C877.516 98.5083 878.893 100.279 878.893 103.428C878.893 107.068 875.942 109.823 873.088 109.823C870.629 109.823 869.645 108.249 867.284 108.249H863.84C862.955 108.249 862.659 108.544 862.659 109.429C862.659 114.25 867.382 122.22 873.974 125.663C875.548 126.45 877.418 126.942 878.795 127.237C879.68 127.434 879.976 127.828 879.976 128.32C879.976 129.599 878.401 129.796 878.401 130.976C878.401 132.255 879.189 133.141 879.189 135.109C879.189 138.454 876.63 140.225 872.695 140.225C864.529 140.225 857.248 133.338 854.69 125.368C854.395 124.581 853.509 124.581 853.214 125.368C850.853 134.223 843.867 141.209 834.127 141.209C830.191 141.209 826.748 139.733 826.748 135.896C826.748 134.125 827.535 133.338 827.535 132.058C827.535 130.878 825.469 130.386 825.469 129.107ZM852.821 163.641C852.821 164.33 853.116 164.625 853.804 164.625H885.879C886.568 164.625 886.863 164.33 886.863 163.641V158.82C886.863 158.131 886.568 157.836 885.879 157.836H853.804C853.116 157.836 852.821 158.131 852.821 158.82V163.641ZM875.843 116.907C875.843 114.841 876.926 113.857 877.811 112.873C878.5 112.184 878.106 111.791 878.106 110.708C878.106 109.331 878.795 108.347 879.779 108.347C880.468 108.347 880.763 108.642 881.648 109.036C882.73 109.528 883.714 109.823 885.78 109.823H886.863V103.329C886.863 100.476 886.272 98.6067 884.01 96.2454C881.747 93.8841 880.271 93.2937 880.271 92.0147C880.271 90.5389 883.222 90.1453 885.78 90.4405C887.355 90.6373 887.748 90.5389 888.24 90.0469C889.224 89.0631 890.601 87.9808 893.553 87.9808C899.063 87.9808 900.735 92.2115 901.818 92.605C903.294 93.1953 905.655 94.5728 905.655 97.7212C905.655 101.263 903.392 102.444 903.392 103.624V135.207C903.392 138.552 898.374 140.126 891.29 140.126C888.339 140.126 886.863 138.946 886.863 136.584V124.581C886.076 124.876 885.387 125.86 883.518 125.86C881.451 125.86 880.566 123.499 880.271 122.908C880.074 122.416 879.68 122.023 879.09 121.728C877.909 121.236 875.843 119.563 875.843 116.907Z",
    fill: "#FFF7D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26086305_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.86 147.221C1094.86 144.681 1096.37 142.413 1098.56 141.129C1110.95 133.866 1119.27 120.41 1119.27 105.011C1119.27 81.9055 1100.54 63.1748 1077.43 63.1748C1069.11 63.1748 1061.35 65.6065 1054.83 69.7984C1052.16 71.5158 1048.66 71.5158 1045.99 69.7984C1039.47 65.6065 1031.72 63.1748 1023.39 63.1748C1015.07 63.1748 1007.31 65.6065 1000.79 69.7984C998.121 71.5159 994.624 71.5159 991.954 69.7984C985.436 65.6065 977.679 63.1748 969.353 63.1748C946.248 63.1748 927.517 81.9055 927.517 105.011C927.517 121.012 936.5 134.916 949.699 141.952C952.035 143.198 953.665 145.539 953.665 148.186V173.629C953.665 191.571 968.209 206.116 986.151 206.116H1062.38C1080.32 206.116 1094.86 191.571 1094.86 173.629V147.221Z",
    fill: "#FFF7CF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321318005_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1050.41 136.955C1043.12 143.128 1033.69 146.849 1023.39 146.849C1013.09 146.849 1003.66 143.127 996.373 136.955C989.083 143.128 979.653 146.849 969.353 146.849C946.248 146.849 927.517 128.119 927.517 105.013C927.517 81.9076 946.248 63.1768 969.353 63.1768C979.653 63.1768 989.083 66.8987 996.372 73.0709C1003.66 66.8987 1013.09 63.1768 1023.39 63.1768C1033.69 63.1768 1043.12 66.8986 1050.41 73.0707C1057.7 66.8986 1067.13 63.1768 1077.43 63.1768C1100.54 63.1768 1119.27 81.9075 1119.27 105.013C1119.27 128.119 1100.54 146.849 1077.43 146.849C1067.13 146.849 1057.7 143.128 1050.41 136.955Z",
    fill: "#FFF7CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.665 148.188C953.665 145.541 952.035 143.2 949.699 141.955C936.5 134.918 927.517 121.015 927.517 105.013C927.517 81.9076 946.248 63.1768 969.353 63.1768C977.678 63.1768 985.436 65.6086 991.953 69.8005C994.624 71.5179 998.121 71.5179 1000.79 69.8005C1007.31 65.6085 1015.07 63.1768 1023.39 63.1768C1031.72 63.1768 1039.47 65.6085 1045.99 69.8003C1048.66 71.5178 1052.16 71.5178 1054.83 69.8003C1061.35 65.6085 1069.1 63.1768 1077.43 63.1768C1100.54 63.1768 1119.27 81.9075 1119.27 105.013C1119.27 120.412 1110.95 133.868 1098.56 141.131C1096.37 142.415 1094.86 144.683 1094.86 147.223V173.631C1094.86 191.573 1080.32 206.117 1062.38 206.117H986.151C968.209 206.117 953.665 191.573 953.665 173.631V148.188Z",
    fill: "url(#paint6_linear_1932_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1933_2",
    d: "M981.159 59.9277C990.905 61.0106 1001.73 72.7058 1006.07 80.5025",
    stroke: "#634E3E",
    strokeWidth: 8.66307,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1934_2",
    d: "M1034.22 59.9277C1043.97 61.0106 1054.8 72.7058 1059.13 80.5025",
    stroke: "#634E3E",
    strokeWidth: 8.66307,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68_2",
    cx: 955.672,
    cy: 65.5876,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72_2",
    cx: 937.263,
    cy: 81.8317,
    r: 3.24865,
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 69_2",
    cx: 1072.62,
    cy: 63.4216,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70_2",
    cx: 1033.64,
    cy: 80.7488,
    r: 2.16577,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71_2",
    cx: 1009.82,
    cy: 63.4221,
    r: 1.73261,
    fill: "#FF6B00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086307_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465512_2",
    x: 1087.8,
    y: 61.5898,
    width: 6.4973,
    height: 19.4919,
    rx: 3.24865,
    transform: "rotate(-28.963 1087.8 61.5898)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465513_2",
    x: 976.787,
    y: 55.0264,
    width: 6.4973,
    height: 26.4494,
    rx: 3.24865,
    transform: "rotate(45.0091 976.787 55.0264)",
    fill: "#FFA6CB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465514_2",
    x: 984.152,
    y: 66.5342,
    width: 2.73267,
    height: 8.19802,
    rx: 1.36634,
    transform: "rotate(-14.7713 984.152 66.5342)",
    fill: "#FF6FAC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465515_2",
    x: 1023.63,
    y: 65.625,
    width: 2.73267,
    height: 11.1566,
    rx: 1.36634,
    transform: "rotate(-114.181 1023.63 65.625)",
    fill: "#89C7FF"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465513_3",
    x: 97.5083,
    y: 452.328,
    width: 14.7493,
    height: 55.5438,
    rx: 7.37467,
    transform: "rotate(45.0091 97.5083 452.328)",
    fill: "#FFA6CB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3465514_3",
    x: 1011.93,
    y: 587.068,
    width: 10.6645,
    height: 41.258,
    rx: 5.33227,
    transform: "rotate(-28.963 1011.93 587.068)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72_3",
    cx: 29.347,
    cy: 289.459,
    r: 5.41442,
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_7",
    cx: 947.632,
    cy: 443.23,
    r: 5.41442,
    fill: "#2998FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74_7",
    cx: 1120.89,
    cy: 285.128,
    r: 7.58019,
    fill: "#FF5CA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1932_3241",
    x: 0.108887,
    y: -8.33299,
    width: 1147.86,
    height: 680.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -10.8288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.33153
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1932_3241"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1932_3241",
    x: 224.528,
    y: 315.712,
    width: 24.3506,
    height: 24.3476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1932_3241",
    x: 234.012,
    y: 337.107,
    width: 15.1601,
    height: 15.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1932_3241",
    x: 266.499,
    y: 371.759,
    width: 15.1601,
    height: 15.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1932_3241",
    x: 444.276,
    y: 288.562,
    width: 28.1328,
    height: 15.9189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1932_3241",
    x: 425.491,
    y: 362.905,
    width: 12.9946,
    height: 12.9951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1932_3241",
    x: 441.96,
    y: 310.046,
    width: 15.1601,
    height: 15.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1932_3241",
    x: 437.666,
    y: 357.351,
    width: 15.1601,
    height: 15.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1932_3241",
    x: 651.527,
    y: 374.048,
    width: 25.9756,
    height: 22.3652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1932_3241",
    x: 671.385,
    y: 370.85,
    width: 15.1616,
    height: 15.1621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1932_3241",
    x: 698.974,
    y: 332.183,
    width: 15.1616,
    height: 15.1621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1932_3241",
    x: 814.854,
    y: 315.712,
    width: 24.3506,
    height: 24.3476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1932_3241",
    x: 824.337,
    y: 337.107,
    width: 15.1601,
    height: 15.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1932_3241",
    x: 856.824,
    y: 371.759,
    width: 15.1604,
    height: 15.1601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_1932_3241",
    x: 257.976,
    y: 534.658,
    width: 25.9756,
    height: 22.3652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_1932_3241",
    x: 277.834,
    y: 531.458,
    width: 15.1616,
    height: 15.1621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_1932_3241",
    x: 305.422,
    y: 492.791,
    width: 15.1616,
    height: 15.1621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08288
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.305882 0 0 0 0 0.243137 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_1932_3241",
    x: 228.219,
    y: 83.6489,
    width: 690.431,
    height: 118.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.66307
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.4973
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289191 0 0 0 0 0.209842 0 0 0 0 0.149386 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1932_3241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1932_3241",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1932_3241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(277.327 342.521) rotate(90) scale(67.1388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.579865,
    stopColor: "#FFD28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92692D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1932_3241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(474.103 342.521) rotate(138.34) scale(67.1388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.579865,
    stopColor: "#FFD28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92692D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1932_3241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(670.878 342.522) rotate(-11.3391) scale(67.1388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.579865,
    stopColor: "#FFD28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92692D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1932_3241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(867.653 342.521) rotate(90) scale(67.1388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.579865,
    stopColor: "#FFD28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92692D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1932_3241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(277.326 503.131) rotate(-11.3391) scale(67.1388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.579865,
    stopColor: "#FFD28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92692D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1932_3241",
    x1: 126.304,
    y1: 61.9473,
    x2: 126.304,
    y2: 165.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1932_3241",
    x1: 1023.39,
    y1: 63.1768,
    x2: 1023.39,
    y2: 167.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1932_3241"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.481,
    y: 264.229,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1932_3241"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.257,
    y: 264.229,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1932_3241"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.706,
    y: 424.839,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignSet1);
export default __webpack_public_path__ + "static/media/DesignSet1.705210554ca063286b76feb1be18b858.svg";
export { ForwardRef as ReactComponent };